import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

import {
  Case,
  Default,
  Switch,
} from "../components/common/ConditionalRendering";
import SupervisionModeRoute from "../components/Supervision/SupervisionModeRoute";
import DashboardLayout from "../layout/DashboardLayout";

const ProviderTaggingRoute = () => {
  const user = useSelector(state => state.auth.user);

  return (
    <Switch>
      <Case condition={!user}>
        <Navigate to="/login" replace />
      </Case>

      <Default>
        <SupervisionModeRoute>
          <DashboardLayout>
            <Outlet />
          </DashboardLayout>
        </SupervisionModeRoute>
      </Default>
    </Switch>
  );
};

export default ProviderTaggingRoute;
